import React, { useMemo } from 'react';
import { handleHighlightKeyword } from 'src/utils';
import './index.scss';
const clsPrefix = 'cn-intelli-assistant-highlight-content';
export function HighlightContent(props) {
    const { content, keywords } = props;
    const res = useMemo(() => {
        // const
        return handleHighlightKeyword({ content, keywords, className: `${clsPrefix}-keyword` });
    }, [content, keywords]);
    return res.hasHighlight ? (React.createElement("span", { className: `${clsPrefix}`, dangerouslySetInnerHTML: { __html: res.html } })) : React.createElement(React.Fragment, null, content);
}
export default HighlightContent;
